
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 341.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FF9811","d":"M0-40.8v422.9-211.4z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M0 0h512v341.3H0z"}}),_c('g',{attrs:{"fill":"#0052B4"}},[_c('path',{attrs:{"d":"M0 0h512v68.3H0zM0 136.5h512v68.3H0zM0 273.1h512v68.3H0z"}})]),_c('path',{attrs:{"fill":"#D80027","d":"M256 170.7L0 341.3V0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M81.5 94.8l16.9 51.9H153l-44.2 32.1 16.9 52-44.2-32.1-44.2 32.1 16.9-52L10 146.7h54.6z"}})])
          )
        }
      }
    